// Detect if the user is using touch events
window.addEventListener('touchstart', function touched() {
	document.body.classList.add('touch');
	this.window.removeEventListener('touchstart', touched,
	false);
}, false)
